import { render, staticRenderFns } from "./AdditionalInfoPanel.vue?vue&type=template&id=112d24a6&"
import script from "./AdditionalInfoPanel.vue?vue&type=script&lang=js&"
export * from "./AdditionalInfoPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports